import { render, staticRenderFns } from "./Competence.vue?vue&type=template&id=1a777cd8&scoped=true"
import script from "./Competence.vue?vue&type=script&lang=js"
export * from "./Competence.vue?vue&type=script&lang=js"
import style0 from "./Competence.vue?vue&type=style&index=0&id=1a777cd8&prod&lang=scss&scoped=true"
import style1 from "./Competence.vue?vue&type=style&index=1&id=1a777cd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a777cd8",
  null
  
)

export default component.exports